const ITEMS = [
  "Come Back",
  "Discover Africa Differently",
  "Tourism",
  "Relocation",
  "Diaspora Return",
  "Investment",
  "36 States + FCT",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-jawa-stone bg-jawa-ivory py-8"
    >
      <div className="animate-jawa-marquee flex w-max items-baseline gap-12 pr-12">
        {row.map((item, i) => (
          <span key={i} className="flex items-baseline gap-12">
            <span className="whitespace-nowrap font-serif text-5xl font-medium tracking-tight text-jawa-espresso/15 sm:text-6xl">
              {item}
            </span>
            <span className="h-2 w-2 shrink-0 rounded-full bg-jawa-terracotta/40" />
          </span>
        ))}
      </div>
    </div>
  );
};
